import styled from "styled-components";

export const MainContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 2rem;
    padding: 2rem;
    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
    min-height: calc(100vh - 200px);
`;

export const Cards = styled.div`
    height: 400px;
    background: white;
    padding: 1.5rem;
    border-radius: 20px;
    width: 320px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    margin: 1rem;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
    border: 1px solid rgba(255, 255, 255, 0.2);

    &:hover {
        transform: translateY(-10px);
        box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
    }
`;

export const RecipeHeader = styled.h1`
    font-size: 1.3rem;
    text-align: center;
    color: #333;
    font-weight: 600;
    margin: 0.5rem 0;
    line-height: 1.4;
    font-family: "Poppins", sans-serif;
`;

export const RecipeImage = styled.img`
    height: 180px;
    width: 100%;
    border-radius: 15px;
    object-fit: cover;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
`;

export const Button = styled.button`
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    padding: 0.8rem 1.5rem;
    height: auto;
    border: none;
    margin: 1rem 0;
    border-radius: 25px;
    cursor: pointer;
    font-size: 0.9rem;
    font-weight: 600;
    transition: all 0.3s ease;
    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
    }
`;

export const ImgDiv = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 4rem 0;
    padding: 2rem;
    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
`;

export const HomeImg = styled.img`
    width: 80%;
    max-width: 600px;
    height: auto;
    opacity: 0.8;
    filter: drop-shadow(0 10px 20px rgba(0, 0, 0, 0.1));
`;
